module.exports = __webpack_public_path__ + "static/media/onlinecoursebg.c1ec9614.png";